module.exports = __webpack_public_path__ + "d3ce295bcc5fb08a9fcacbd171e52b32.png";